import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Line } from "rc-progress";

import {
  GET_PERCENTAGE,
  GET_TOKEN,
  CURRENCY,
} from "../../../helpers";
import { API_URL, GET_TRESHOLDS, POST_TRESHOLD_ORDERS } from "../../../constants";
import { Modal } from "../../Global/Modal/Modal";
import { GET_USER_LEVEL } from "../../../helpers";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./WidgetTresholdLimitMonitor.css";

export const WidgetTresholdLimitMonitor = (props) => {
  const [tresholdsByCountry, setTresholdsByCountry] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalFormDisabled, setModalFormDisabled] = useState(false);

  const [modalFormfields, setModalFormFields] = useState({
    name: '',
    email: '',
    body: ''
  })

  useEffect(() => {
    if (modalFormfields.name.length <= 0) return setModalFormDisabled(true)
    if (modalFormfields.email.length <= 0) return setModalFormDisabled(true)
    if (modalFormfields.body.length <= 0) return setModalFormDisabled(true)

    setModalFormDisabled(false)
  }, [modalFormfields])

  useEffect(() => {
    !modalOpen &&
      setModalFormFields({
        name: '',
        email: '',
        body: ''
      })
  }, [modalOpen])

  useEffect(() => {
    setDataLoaded(false);
    // let hasDates = props.filterPayload.from || props.filterPayload.to;

    const generateString = () => {
      let resultString = "/?";
      const querryString = {
        from:
          (props.filterPayload && props.filterPayload.from) &&
            props.filterPayload.from.getFullYear() +
            "-" +
            ( props.filterPayload.from.getMonth() + 1) +
            "-" +
            props.filterPayload.from.getDate(),
        to:
          (props.filterPayload && props.filterPayload.to) &&
            props.filterPayload.to.getFullYear() +
            "-" +
            ( props.filterPayload.to.getMonth() + 1) +
            "-" +
            props.filterPayload.to.getDate(),
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined && fieldItemValue !== null) {
          return (resultString = resultString.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return resultString;
    };

    fetch(API_URL + GET_TRESHOLDS + generateString() + `region=${props.countryFilter || 'all'}`, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setTresholdsByCountry(response);
      })
      .then(() => setDataLoaded(true));
    
  //eslint-disable-next-line
  }, [props.countryFilter, props.filterPayload]);

  const colors = {
    positive: "#92D9A9",
    negative: "#EC3E65",
    background: "#F5F9FC",
  };

  const renderWithoutTreshold = (item, percentOfValues, overTreshold) => {
    return (
      <div className="country-item__treshold">
        <div
          className={"current-price " + ((overTreshold && " warning") || "")}
          style={{
            marginLeft:
              (percentOfValues >= 100 && "0") ||
              (percentOfValues - 3 >= 0 && percentOfValues - 3 + "%") ||
              "0%",
          }}
        >
          {/* should be visible only as a widget */}
          {item.message && (
            <>
              <div className="country-item__treshold-message half warning flex-align-center">
                {item.message}

                <br/>

                {item.condition_reached_at && `(Date: ${item.condition_reached_at})`}

                {overTreshold && <div className="icon error-icon-two"></div>}
              </div>
            </>
          )}
          <div className="move-right">
            
            {CURRENCY(item.price, item.currencySymbol)} 
          </div>
        </div>
        <Line
          percent={percentOfValues}
          strokeWidth="1"
          strokeColor={
            (item.price < item.treshold && colors.positive) || colors.negative
          }
          trailColor={colors.background}
        />
        <div className="min-max-treshold-row">
          <span>{CURRENCY(0, item.currencySymbol)}</span>
          <span>
            {item.treshold && CURRENCY(item.treshold, item.currencySymbol)}
          </span>
        </div>
      </div>
    );
  };

  const renderWithTreshold = (item, percentOfValues, overTreshold) => {
    return (
      <div className="flex">
        <div className="country-item__treshold full-width gutter-sm-r">
          <h5>Revenue</h5>

          <div
            className={"current-price " + ((overTreshold && " warning") || "")}
            style={{
              marginLeft:
                (percentOfValues >= 100 && "0") ||
                (percentOfValues - 3 >= 0 && percentOfValues - 3 + "%") ||
                "0%",
            }}
          >
            {CURRENCY(item.price, item.currencySymbol)}
          </div>
          <Line
            percent={percentOfValues}
            strokeWidth="2"
            strokeColor={
              (item.price < item.treshold && colors.positive) || colors.negative
            }
            trailColor={colors.background}
          />
          <div className="min-max-treshold-row">
            <span>{CURRENCY(0, item.currencySymbol)}</span>
            <span>{CURRENCY(item.treshold, item.currencySymbol)}</span>
          </div>
        </div>

        <div className="country-item__treshold full-width gutter-sm-l">
          <h5>Transactions</h5>
          <div
            className={
              "current-price " +
              ((item.transactionsCount >= item.transactionsLimit &&
                " warning") ||
                "")
            }
            style={{
              marginLeft:
                (GET_PERCENTAGE(
                  item.transactionsCount,
                  item.transactionsLimit
                ) >= 100 &&
                  "0") ||
                (GET_PERCENTAGE(
                  item.transactionsCount,
                  item.transactionsLimit
                ) -
                  3 >=
                  0 &&
                  GET_PERCENTAGE(
                    item.transactionsCount,
                    item.transactionsLimit
                  ) -
                    3 +
                    "%") ||
                "0%",
            }}
          >
            {item.transactionsCount}
          </div>
          <Line
            percent={GET_PERCENTAGE(
              item.transactionsCount,
              item.transactionsLimit
            )}
            strokeWidth="2"
            strokeColor={
              (item.transactionsCount < item.transactionsLimit &&
                colors.positive) ||
              colors.negative
            }
            trailColor={colors.background}
          />
          <div className="min-max-treshold-row">
            <span>0</span>
            <span>{item.transactionsLimit}</span>
          </div>
        </div>
      </div>
    );
  };

  const submitRegister = (id) => {

    const body = JSON.stringify({
      threshold_data_id: id
    })

    fetch(API_URL + POST_TRESHOLD_ORDERS, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body
    })
    .then((response) => response.json())
    .then((response) => {
      let newArray = [...tresholdsByCountry]

      tresholdsByCountry.find((item, index) => {
        if (item.id === id) {
          item.hasOrder = true
  
          return newArray[index] = item
        }
      })
  
      setTresholdsByCountry([...newArray])
    })
  }

  const listOfTresholds = () => {
    return tresholdsByCountry.map((item, index) => {
      let percentOfValues = GET_PERCENTAGE(item.price, item.treshold);
      let overTreshold = item.price >= item.treshold;

      return (
        <div className="country-item" key={item.price + index + 'item'}>
          <div className="country-item__info">
            <div className="country-item__name flex-align-center">
              {item.img && (
                <img src={item.img} className="flag-icon-img" alt={item.name} />
              )}

              {item.name}

              {/* should be visible only as a full page */}
              {item.message && (
                <>
                  <span> | </span>
                  <div className="country-item__treshold-message warning full flex-align-center">
                    {item.message}

                    {item.condition_reached_at && ` (Date: ${item.condition_reached_at})`}

                    {overTreshold && (
                      <div className="icon error-icon-two"></div>
                    )}

                  </div>
                </>
              )}

              {
                item.type && (
                  <span className="country-item__treshold-type"> {item.type} </span>
                )
              }
            </div>
            
            {/* eslint-disable-next-line */}
            {
              GET_USER_LEVEL() === "2" && (
                <>
                  <button 
                    className={`register ${item.hasOrder ? 'has_order' : ''}`}
                    // className={`register `}
                    onClick={(e) => {
                      if (!item.hasOrder) {
                        submitRegister(item.id)
                      }
                    }}
                  >
                    {item.hasOrder 
                      ? 'Request sent'
                      : overTreshold ? "Register now" : "Voluntary registration"
                    }
                  </button>
                </>
              )
            }

          </div>

          {item.transactionsCount
            ? renderWithTreshold(item, percentOfValues, overTreshold)
            : renderWithoutTreshold(item, percentOfValues, overTreshold)}
        </div>
      );
    });
  };

  // const handleContactUs = () => {
  //   const body = JSON.stringify({modalFormfields})

  //   fetch(API_URL + POST_TRESHOLD_ORDERS, {
  //     method: "POST",
  //     headers: new Headers({
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + GET_TOKEN(),
  //     }),
  //     body: body,
  //   })
  //   .then((response) => response.json())
  //   .then((response) => {

  //     response.error 
  //       ? console.log(response.error)
  //       : console.log('Form submited succesfully')
  //   })
  //   .then(() => setModalOpen(false))
  //   .then(() => {
  //     setModalFormFields({
  //       name: '',
  //       email: '',
  //       body: ''
  //     })
  //   })
  //   .catch(error => console.log(error));
  // }

  return (
    <div className={"widget " + (props.width ? props.width : "")}>
      {props.hideTitle ? (
        <></>
      ) : (
        <div className="widget__title-wrapper flex">
          <h2 className={props.hideTitle ? "hide" : ""}>
            Treshold limit Monitor
          </h2>
          <Link
            className="widget__title-wrapper__link flex"
            to={"/dashboard/tresholds"}
            exact="true"
          >
            View full report <div className="icon arrow-right"></div>
          </Link>
        </div>
      )}

      <div
        className={
          "WidgetTresholdLimitMonitor " +
          (props.width ? "widget-content" : "") +
          " " +
          (props.border ? props.border : "")
        }
      >
        {tresholdsByCountry.length > 0 && dataLoaded ? (
          listOfTresholds()
        ) : dataLoaded 
          ? <EmptyData title="You don’t have any threshold data" type="tasks" />
          : <div className="loading">
              <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          }

        {/* <Modal
          ModalOpen={modalOpen}
          ModalOpenHandler={(value) => setModalOpen(value)}
          closeButton={true}
          customClassName={'modal__form_tresholds'}
          title={'Contact Us'}
        >

          <input 
            type="text"
            placeholder='Message Title'
            className='default-input'
            value={modalFormfields.name}
            onChange={(e) => setModalFormFields({
              ...modalFormfields,
              name: e.target.value
            })}
          />

          <input 
            type="text"
            placeholder='Your Email'
            className='default-input'
            value={modalFormfields.email}
            onChange={(e) => setModalFormFields({
              ...modalFormfields,
              email: e.target.value
            })}
          />
          
          
          <textarea  
            placeholder='Please describe how 1stopvat.com can help you'
            value={modalFormfields.body}
            className='default-input message'
            onChange={(e) => setModalFormFields({
              ...modalFormfields,
              body: e.target.value
            })}
          />

          <div className="Modal__submit-wrapper">
            <button 
              onClick={() => handleContactUs()}
              disabled={modalFormDisabled}
            >
              submit
            </button>
          </div>



        </Modal> */}
      </div>
    </div>
  );
};
